import { useEffect, useState } from "react";
import { ReloadOutlined, InfoCircleTwoTone } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { Table, Modal, Pagination, Switch } from "antd";

import {
  DeleteIcon,
  EditIcon,
  PlusIcon,
} from "../../../SharedComponents/icons/icons";
import { types } from "../../../store/action_types";

import SearchBarPro from "../../../SharedComponents/SearchBarPro";
import BlockchainCard from "../../../SharedComponents/BlockchainCard";
import AddOrEditBlockchain from "../../../SharedComponents/AddOrEditBlockchain";

const ModalType = {
  ADD: "add",
  EDIT: "edit",
  INFO: "info",
};

const Blockchains = () => {
  const { confirm } = Modal;

  const { blockchains, getLoading, deleteLoading, pagination } = useSelector(
    (state) => state.BlockchainsReducer
  );
  const dispatch = useDispatch();

  const [modal, setModal] = useState(null);
  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [refresh, setRefresh] = useState(0);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [currentBlockchain, setCurrentBlockchain] = useState(null);

  const loading = getLoading || deleteLoading;
  const blockchainsColums = [
    {
      title: "",
      dataIndex: "iconImgUrl",
      key: "iconImgUrl",
      width: 40,
      render: (item) => <img src={item} className="taskavatarimage" />,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (item) => <div>{item}</div>,
    },
    {
      title: "Symbol",
      dataIndex: "symbol",
      key: "symbol",
      width: 100,
      render: (item) => <div>{item}</div>,
    },
    {
      title: "in USD",
      dataIndex: "priceInUsd",
      key: "priceInUsd",
      width: 100,
      render: (item) => <div>{item}</div>,
    },

    {
      title: "Status",
      dataIndex: "",
      key: "socialHub",
      width: 50,
      render: (item) => (
        <Switch onClick={() => {}} checked={item.status} disabled />
      ),
    },
    {
      title: "Actions",
      dataIndex: "",
      key: "x",
      width: 90,
      render: (item) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          key={item._id}
          className="d-flex"
        >
          <div
            className="ml10 cursor"
            onClick={() => {
              handleOpenInfoModal(item);
            }}
          >
            <InfoCircleTwoTone style={{ fontSize: "20px", paddingTop: 2 }} />
          </div>
          <div
            className="ml10 cursor"
            onClick={() => {
              handleOpenEditModal(item);
            }}
          >
            <EditIcon />
          </div>
          <div
            className="ml10 cursor"
            onClick={() => {
              handlDeleteRecord(item._id, item.name);
            }}
          >
            <DeleteIcon />
          </div>
        </div>
      ),
    },
  ];

  const handlDeleteRecord = (id, name) => {
    confirm({
      title: `Delete "${name}" blockchain`,
      content: `Are you sure to delete this blockchain?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      centered: true,
      onOk() {
        dispatch({
          type: types.DeleteBlockchainsRequest,
          payload: {
            blockchainId: id,
            page,
          },
        });
      },
      onCancel() {},
    });
  };
  const handleOpenAddModal = () => {
    setModal(ModalType.ADD);
  };
  const handleOpenEditModal = (record) => {
    setCurrentBlockchain(record);
    setModal(ModalType.EDIT);
  };
  const handleOpenInfoModal = (record) => {
    setCurrentBlockchain(record);
    setModal(ModalType.INFO);
  };
  const handleCloseModal = () => {
    setCurrentBlockchain(null);
    setModal(null);
    setIsFirstTime(true);
  };
  const handleSearch = (searchText) => {
    setSearchText(searchText);
    dispatch({
      type: types.GetBlockchainsRequest,
      payload: {
        page,
        searchText,
      },
    });
  };
  const handleChangePage = (page) => {
    dispatch({
      type: types.GetBlockchainsRequest,
      payload: {
        page,
        searchText,
      },
    });

    setPage(page);
  };

  useEffect(() => {
    dispatch({
      type: types.GetBlockchainsRequest,
      payload: {
        page,
      },
    });
  }, [refresh]);

  return (
    <div className="relative">
      <div className="header">
        <div className="headerContent">
          <h2>Blockchains</h2>
          <SearchBarPro
            searchText={searchText}
            setSearchText={setSearchText}
            onSearch={handleSearch}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 16,
          }}
        >
          <div
            className="addbtn"
            onClick={() => {
              setRefresh((prev) => prev + 1);
            }}
          >
            <ReloadOutlined />
          </div>
          <div className="addbtn" onClick={handleOpenAddModal}>
            Add Blockchain <PlusIcon />
          </div>
        </div>
      </div>

      <Table
        pagination={false}
        columns={blockchainsColums}
        dataSource={blockchains}
        loading={loading}
      />

      <div className="d-flex justify-content-end mt20">
        <Pagination
          current={page}
          pageSize={pagination?.itemsPerPage || limit}
          total={pagination?.totalDocs || 0}
          onChange={(page) => handleChangePage(page)}
          showSizeChanger={false}
        />
      </div>

      <Modal
        title={false}
        footer={false}
        centered={true}
        open={modal === ModalType.INFO}
        onCancel={handleCloseModal}
        width={600}
      >
        <BlockchainCard blockchain={currentBlockchain} />
      </Modal>

      <Modal
        title={false}
        footer={false}
        centered={true}
        open={!!modal && modal !== ModalType.INFO}
        onCancel={handleCloseModal}
        width={500}
      >
        <AddOrEditBlockchain
          handleCloseModal={handleCloseModal}
          setIsFirstTime={setIsFirstTime}
          isFirstTime={isFirstTime}
          currentBlockchain={currentBlockchain}
          isEdit={modal === ModalType.EDIT}
          page={page}
        />
      </Modal>
    </div>
  );
};

export default Blockchains;
